var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1256_18076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7229 45C18.6594 45 17.744 44.6625 16.9766 43.9875C16.2093 43.3125 15.7461 42.4875 15.5869 41.5125L15.0551 37.8C14.5431 37.6125 14.0609 37.3875 13.6087 37.125C13.1565 36.8625 12.713 36.5812 12.2781 36.2812L8.61476 37.7437C7.62999 38.1562 6.64522 38.1938 5.66045 37.8563C4.67568 37.5188 3.90756 36.9188 3.35609 36.0562L0.579044 31.4438C0.0275732 30.5813 -0.129989 29.6625 0.106355 28.6875C0.3427 27.7125 0.874475 26.9062 1.70168 26.2688L4.83325 24.0188C4.79386 23.7563 4.77416 23.5028 4.77416 23.2582V21.7395C4.77416 21.4965 4.79386 21.2437 4.83325 20.9812L1.70168 18.7312C0.874475 18.0938 0.3427 17.2875 0.106355 16.3125C-0.129989 15.3375 0.0275732 14.4187 0.579044 13.5562L3.35609 8.94375C3.90756 8.08125 4.67568 7.48125 5.66045 7.14375C6.64522 6.80625 7.62999 6.84375 8.61476 7.25625L12.2781 8.71875C12.7114 8.41875 13.1644 8.1375 13.6371 7.875C14.1098 7.6125 14.5825 7.3875 15.0551 7.2L15.5869 3.4875C15.7445 2.5125 16.2077 1.6875 16.9766 1.0125C17.7455 0.3375 18.661 0 19.7229 0H25.277C26.3406 0 27.2568 0.3375 28.0257 1.0125C28.7946 1.6875 29.2571 2.5125 29.4131 3.4875L29.9448 7.2C30.4569 7.3875 30.9399 7.6125 31.3936 7.875C31.8474 8.1375 32.2902 8.41875 32.7219 8.71875L36.3852 7.25625C37.37 6.84375 38.3548 6.80625 39.3395 7.14375C40.3243 7.48125 41.0924 8.08125 41.6439 8.94375L44.421 13.5562C44.9724 14.4187 45.13 15.3375 44.8936 16.3125C44.6573 17.2875 44.1255 18.0938 43.2983 18.7312L40.1668 20.9812C40.2061 21.2437 40.2258 21.4972 40.2258 21.7418V23.2582C40.2258 23.5028 40.1865 23.7563 40.1077 24.0188L43.2392 26.2688C44.0664 26.9062 44.5982 27.7125 44.8346 28.6875C45.0709 29.6625 44.9133 30.5813 44.3619 31.4438L41.5257 36.0562C40.9743 36.9188 40.2061 37.5188 39.2214 37.8563C38.2366 38.1938 37.2518 38.1562 36.2671 37.7437L32.7219 36.2812C32.2886 36.5812 31.8356 36.8625 31.3629 37.125C30.8902 37.3875 30.4175 37.6125 29.9448 37.8L29.4131 41.5125C29.2555 42.4875 28.7931 43.3125 28.0257 43.9875C27.2584 44.6625 26.3422 45 25.277 45H19.7229ZM22.6182 30.375C24.9028 30.375 26.8527 29.6063 28.4677 28.0688C30.0827 26.5312 30.8902 24.675 30.8902 22.5C30.8902 20.325 30.0827 18.4688 28.4677 16.9312C26.8527 15.3937 24.9028 14.625 22.6182 14.625C20.2941 14.625 18.334 15.3937 16.7379 16.9312C15.1418 18.4688 14.3445 20.325 14.3461 22.5C14.3461 24.675 15.1442 26.5312 16.7403 28.0688C18.3364 29.6063 20.2957 30.375 22.6182 30.375Z",
    fill: "#3B7EB2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1256_18076",
    x: 0,
    y: 0,
    width: 45,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1256_18076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.e60aeae612a62e95ce3c753eada604ed.svg";
export { ForwardRef as ReactComponent };